export const routes = {
  productView: (productId: number, colorId?: number) => {
    let url = `/products/${productId}`;
    if (colorId) {
      url += `?color_id=${colorId}`;
    }
    return url;
  },
};